/* © CNES */
/**
 * Constants STAC variables.
 */
export const CLOUD_COVER = 'eo:cloud_cover';
export const PROCESSING_LEVEL = 'processing:level';
export const ORBIT_STATE = 'sat:orbit_state';
export const ORBIT_ABSOLUTE = 'sat:absolute_orbit';
export const ORBIT_RELATIVE = 'sat:relative_orbit';
export const ORBIT_CYCLE = 'sat:orbit_cycle';
export const INSTRUMENT_MODE = 'sar:instrument_mode';
export const POLARIZATIONS = 'sar:polarizations';
export const PRODUCT_TYPE = 'product:type';
export const PRODUCT_TIMELINESS = 'product:timeliness';
export const PLATFORM = 'platform';
export const INSTRUMENT = 'instrument';
export const KEYWORDS = 'keywords';
export const START_DATE_TIME = 'start_datetime';
export const END_DATE_TIME = 'end_datetime';
export const DATASET = 'dataset';
export const PPARAMETER = 'pparameter';
export const POLITICAL = 'political';
export const VERSION = 'version';
export const NO_GEOMETRY = 'no_geometry';
export const IDENTIFIER = 'identifier';
export const END_POINT_URL = 'endpoint_url';

export const PARAMETER = 'parameter';
export const EO_SNOW_COVER = 'eo:snow_cover';
export const WATER_COVER = 'water_cover';
export const BANDS = 'bands';
export const S2_DATATAKE_ID = 's2:datatake_id';
export const S2_DATATAKE_TYPE = 's2:datatake_type';
export const S2_DATASTRIP_ID = 's2:datastrip_id';
export const VIEW_INCIDENCE_ANGLE = 'view:incidence_angle';
export const VIEW_AZIMUTH = 'view:azimuth';
export const VIEW_SUN_AZIMUTH = 'view:sun_azimuth';
export const VIEW_SUN_ELEVATION = 'view:sun_elevation';
export const VIEW_OFF_NADIR = 'view:off_nadir';
export const SWATH = 'swath';
export const SWATH_MODE = 'swath_mode';
export const DATETIME = 'datetime';
export const PRODUCT_TIMELINESS_CATEGORY = 'product:timeliness_category';
export const PRODUCT_ACQUISITION_TYPE = 'product:acquisition_type';
export const PROCESSING_CONTEXT = 'processing_context';
export const PROCESSING_CORRECTION = 'processing_correction';
export const PROCESSING_DATETIME = 'processing:datetime';
export const PROCESSING_LINEAGE = 'processing:lineage';
export const PROCESSING_VERSION = 'processing:version';
export const SAR_FREQUENCY_BAND = 'sar:frequency_band';
export const SAR_CENTER_FREQUENCY = 'sar:center_frequency';
export const SAR_RESOLUTION_RANGE = 'sar:resolution_range';
export const SAR_RESOLUTION_AZIMUTH = 'sar:resolution_azimuth';
export const SAR_PIXEL_SPACING_RANGE = 'sar:pixel_spacing_range';
export const SAR_PIXEL_SPACING_AZIMUTH = 'sar:pixel_spacing_azimuth';
export const SAR_LOOKS_RANGE = 'sar:looks_range';
export const SAR_LOOKS_AZIMUTH = 'sar:looks_azimuth';
export const SAR_LOOKS_EQUIVALENT_NUMBER = 'sar:looks_equivalent_number';
export const SAR_OBSERVATION_DIRECTION = 'sar:observation_direction';
export const SAR_RELATIVE_BURST = 'sar:relative_burst';
export const SAR_BEAM_IDS = 'sar:beam_ids';
export const SENSOR_ANGLE = 'sensor_angle';
export const SENSOR_PITCH = 'sensor_pitch';
export const SENSOR_ROLL = 'sensor_roll';
export const RASTER_SPATIAL_RESOLUTION = 'raster:spatial_resolution';
export const TEMPORAL_RESOLUTION = 'temporal_resolution';
export const RESOLUTION_MODE = 'resolution_mode';
export const MISSION_TAKE_ID = 'mission_take_id';
export const GERALD_NAME = 'gerald_name';
export const ACQUISITION_STATION = 'acquisition_station';
export const CLASSIFICATION = 'classification';
export const THEMES = 'themes';
export const PROCESSING_FACILITY = 'processing:facility';
export const MISSION = 'mission';
export const PROCESSING_WEATHERDATA = 'processing.weatherData';
export const PRODUCT_VALIDITY = 'product_validity';
export const VISIBILITY = 'visibility';
export const GRID_CODE = 'grid:code';
export const COUPLING_MODES = 'coupling_modes';
export const NODATA_PIXEL = 'nodata_pixel';
